var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload24PxOutlined1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/file/upload_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 16.5V10.5H19L12 3.5L5 10.5H9V16.5H15ZM12 6.33L14.17 8.5H13V14.5H11V8.5H9.83L12 6.33ZM19 20.5V18.5H5V20.5H19Z",
    fill: "#338F86"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload24PxOutlined1);
export default __webpack_public_path__ + "static/media/upload_24px_outlined (1).aa96321aa24d1dd31befdd3477e92bc2.svg";
export { ForwardRef as ReactComponent };